import { Vertical } from '@gravitate-js/excalibrr'
import React from 'react'

import { invoiceStatusConfig } from './types'
// Import components and hooks
import { ByGroupGrid, FlatInvoiceGrid, InvoiceFilterTabs } from './components'
import { useInvoiceState } from './hooks/useInvoiceState'
import type { CostRevenueType } from './useGridFilters'

/**
 * Main Invoices page component
 * Uses extracted hooks for state management and filter logic
 */
export function Invoices() {
  // Get all state and handlers from the hook
  const {
    isLoading,
    activeStatus,
    setActiveStatus,
    costRevenue,
    setCostRevenue,
    sentDateRangeFilter,
    handleDateRangeChange,
    selectedViewStyle,
    setSelectedViewStyle,
    filteredData,
    statusCounts,
    serverFilters,
    setServerFilters,
    invoicesData,
  } = useInvoiceState()

  return (
    <Vertical>
      <InvoiceFilterTabs
        activeStatus={activeStatus as string}
        setActiveStatus={setActiveStatus}
        costRevenue={costRevenue as CostRevenueType}
        setCostRevenue={setCostRevenue}
        sentDateRangeFilter={sentDateRangeFilter}
        handleDateRangeChange={handleDateRangeChange as (dates: [Date | undefined, Date | undefined]) => void}
        statusCounts={statusCounts}
        statusConfig={invoiceStatusConfig}
      />
      {selectedViewStyle === 'grouped' ? (
        <ByGroupGrid
          isLoading={isLoading}
          filteredData={filteredData}
          activeStatus={activeStatus as string}
          costRevenue={costRevenue as CostRevenueType}
          setSelectedViewStyle={setSelectedViewStyle}
          selectedViewStyle={selectedViewStyle}
          //@ts-ignore
          serverParams={invoicesData?.params}
          //@ts-ignore
          setServerFilters={setServerFilters}
          gridFilters={serverFilters}
        />
      ) : (
        <FlatInvoiceGrid
          selectedViewStyle={selectedViewStyle}
          setSelectedViewStyle={setSelectedViewStyle}
          data={filteredData}
          //@ts-ignore
          serverParams={invoicesData?.params}
          //@ts-ignore
          setServerFilters={setServerFilters}
          //@ts-ignore
          filters={serverFilters}
          costRevenue={costRevenue as CostRevenueType}
        />
      )}
    </Vertical>
  )
}
